"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LayoutPagingTable = _interopRequireDefault(require("01_core/components/layout/LayoutPagingTable"));
var _ListIconButton = _interopRequireDefault(require("01_core/components/materials/ListIconButton"));
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _KansaAnswerConsts = require("../../common/consts/KansaAnswerConsts");
var _MultiLineText = _interopRequireDefault(require("../components/MultiLineText"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 監査回答検索結果コンポーネント
 *
 * @prop {array} searchResult - 検索結果データ
 * @prop {object} paging - ページング情報
 * @prop {number} paging.viewNum - 表示件数の選択値
 * @prop {number} paging.currentPage - 現在ページ位置
 * @prop {object} [scrollTop] - スクロール位置
 * @prop {number} [scrollTop.index] - スクロール位置(行のindex)
 * @prop {number} [scrollTop.scrollY] - スクロール位置(window.scrollY)
 * @prop {bool} [scrollTop.noSticky] - スクロール位置保持時ヘッダ固定されていなかった場合true
 * @prop {string} kansaTheme - 監査テーマ
 * @prop {string} gyomuCd - 業務コード（1:監査部門、2:被監査部門）
 * @prop {bool} search - 再検索フラグ
 * @prop {bool} soshikiShowAll - 組織名全て表示フラグ
 * @prop {func} changeShowAll - 組織名全て表示変更関数 <br/>
 * シグネチャ:(showAll:bool):void
 * @prop {func} onReferClick - 参照ボタン押下時動作 <br/>
 * シグネチャ：({ kansaTgtNendo: string, kansaTgtJigyoId: string, kansaTgtJigyoNm: string,
                 kansaBumonNm: string, kansaSekininshaNm: string, hiKansaSekininshaNm: string,
                 kansaTheme: string, gyomuCd: string, kansaAnsStsCd: string }): void
 * @prop {func} onRegistClick - 登録／更新ボタン押下時動作 <br/>
 * シグネチャ：({ kansaTgtNendo: string, kansaTgtJigyoId: string, kansaTgtJigyoNm: string,
                 kansaBumonNm: string, kansaSekininshaNm: string, hiKansaSekininshaNm: string,
                 kansaTheme: string, gyomuCd: string, kansaAnsStsCd: string }): void
 * @prop {func} [onScroll] - スクロール時のイベント <br/>
 *　シグネチャ:( {index:number,scrollY:number,noSticky:bool }): void
 * @prop {func} changePage - pagingのcurrentPageを変更する関数<br/>
 * シグネチャ:(nextPage: number): void
 * @prop {func} changeViewNum - pagingのviewNumを変更する関数<br/>
 * シグネチャ:(viewNum: number): void
 * @prop {func} resetPaging - pagingを初期化する関数<br/>
 * シグネチャ:(): void
 */
const KansaAnswerResult = function (props) {
  const {
    intl,
    searchResult,
    onReferClick,
    onRegistClick,
    paging,
    resetPaging,
    changePage,
    changeViewNum,
    scrollTop,
    onScroll,
    getCodeName,
    soshikiShowAll,
    changeShowAll,
    search
  } = props;

  // 検索結果ヘッダ
  const columns = [{
    dataKey: 'jigyoNm',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_AUDIT_BUSINESS
    }),
    width: 250
  }, {
    dataKey: 'bumonNm',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KANSA_BUMON
    }),
    width: 250
  }, {
    dataKey: 'hiBumonNm',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_HI_KANSA_BUMON
    }),
    width: 250
  }, {
    dataKey: 'status',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_AUDIT_ANSWER_STATUS
    }),
    width: 250
  }, {
    dataKey: 'actions',
    label: _stringConsts.STRING_CONSTS.EMPTY,
    direction: 'column'
  }];
  const createRow = data => {
    const kansaInfo = {
      kansaTgtNendo: data.kansaTgtNendo,
      kansaTgtJigyoId: data.kansaTgtJigyoId
    };
    const jigyoNm = _stringUtil.default.emptyToHyphen(data.kansaTgtJigyoNm);
    const bumonNm = _stringUtil.default.emptyToHyphen(soshikiShowAll ? data.kansaBumonNmFull : data.kansaBumonNm);
    const hiBumonNm = /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, soshikiShowAll ? /*#__PURE__*/_react.default.createElement(_MultiLineText.default, null, data.hiKansaBumonNmFull) : /*#__PURE__*/_react.default.createElement(_MultiLineText.default, null, data.hiKansaBumonNm)));
    const status = /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 1
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(getCodeName(_CodeConsts.CODE.KANSA_ANS_STS.KBN, data.kansaAnsStsCd))), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, data.kansaAnsDt)));
    const register = /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      action: "register",
      onClick: () => {
        onRegistClick(kansaInfo);
      }
    });
    const update = /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      action: "update",
      onClick: () => {
        onRegistClick(kansaInfo);
      }
    });
    const detail = /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      action: "detail",
      onClick: () => {
        onReferClick(kansaInfo);
      }
    });
    let actions;
    switch (data.actionKbn) {
      case _KansaAnswerConsts.CONSTS.ACTION_KBN.INSERT:
        actions = [register];
        break;
      case _KansaAnswerConsts.CONSTS.ACTION_KBN.UPDATE:
        actions = [update];
        break;
      case _KansaAnswerConsts.CONSTS.ACTION_KBN.REFER:
        actions = [detail];
        break;
      default:
    }
    return {
      jigyoNm,
      bumonNm,
      hiBumonNm,
      status,
      actions
    };
  };
  return /*#__PURE__*/_react.default.createElement(_LayoutPagingTable.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_SEARCH_RESULT_LIST
    }),
    rowData: searchResult,
    headerHeight: 50,
    createRow,
    columns,
    paging,
    changeViewNum,
    changePage,
    resetPaging,
    scrollTop,
    onScroll,
    reload: search,
    putTypography: true,
    changeCurrentPage: changePage,
    showAll: soshikiShowAll,
    changeShowAll: changeShowAll
  });
};
KansaAnswerResult.propTypes = {
  searchResult: _propTypes.default.array.isRequired,
  paging: _propTypes.default.shape({
    viewNum: _propTypes.default.number.isRequired,
    currentPage: _propTypes.default.number.isRequired
  }).isRequired,
  resetPaging: _propTypes.default.func.isRequired,
  changePage: _propTypes.default.func.isRequired,
  changeViewNum: _propTypes.default.func.isRequired,
  onScroll: _propTypes.default.func,
  scrollTop: _propTypes.default.shape({
    index: _propTypes.default.number,
    scrollY: _propTypes.default.number,
    noSticky: _propTypes.default.bool
  }),
  onReferClick: _propTypes.default.func.isRequired,
  onRegistClick: _propTypes.default.func.isRequired,
  soshikiShowAll: _propTypes.default.bool.isRequired,
  changeShowAll: _propTypes.default.func.isRequired,
  search: _propTypes.default.bool
};
const mapDispatchToProps = dispatch => {
  return {
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk))
  };
};
var _default = exports.default = (0, _CodeUtil.withCodeUtil)((0, _reactRedux.connect)(mapDispatchToProps)((0, _reactIntl.injectIntl)(KansaAnswerResult)));